<template>
  <div class="home-view">
    <nav-header :on-goto-home="onGotoHome" :on-join-us-click="onJoinUsClick" :on-menu-click="onMenuClick" ref="navHeader"></nav-header>

    <join-us v-if="showJoinUs"></join-us>
    <div v-else>
      <div class="picture-bed-box">
        <img class="W100" src="@/assets/banner.png" />
      </div>
      <div v-for="(url, i) in imgs" :key="url" class="picture-bed-box" :id="`picture-bed-box-${i}`">
        <img class="W100" :src="url" />
      </div>
    </div>

    <nav-footer></nav-footer>
  </div>
</template>

<script>
import { NavHeader, NavFooter, JoinUs } from '@/components'

import img1 from '@/assets/1.png'
import img2 from '@/assets/2.png'
import img3 from '@/assets/3.png'
import img4 from '@/assets/4.png'
import img5 from '@/assets/5.png'
import img6 from '@/assets/6.png'
import img7 from '@/assets/7.png'
import img8 from '@/assets/8.png'
import img9 from '@/assets/9.png'
import img10 from '@/assets/10.png'

export default {
  components: {
    NavHeader,
    NavFooter,
    JoinUs
  },
  data () {
    return {
      imgs: [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10],
      showJoinUs: false
    }
  },
  methods: {
    onGotoHome () {
      this.showJoinUs = false
      this.$refs.navHeader.hideMenuDropdown()
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    onJoinUsClick () {
      this.showJoinUs = true
      this.$refs.navHeader.hideMenuDropdown()
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    onMenuClick (key) {
      if (this.showJoinUs) {
        this.showJoinUs = false
      }
      this.$refs.navHeader.hideMenuDropdown()
      this.$nextTick(() => {
        const box = document.querySelector(`#picture-bed-box-${key}`)
        if (box) {
          window.scrollTo({
            top: box.offsetTop - 56,
            behavior: 'smooth'
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.home-view {
  padding-top: 56px;
}
</style>
